<!--
  Listbox options use roving tabindex (APG listbox pattern). The trigger lives in the parent
  (`aria-haspopup`, `aria-controls`); this panel is labelled via `filterLabelId` when provided.
-->
@if (showSearch) {
    <div class="sir-filter-search">
        <sirius-search [control]="control"></sirius-search>
    </div>
}
<ul
    class="sir-filter-options"
    role="listbox"
    (mousedown)="$event.preventDefault()"
    data-cy="filter-dropdown-options"
    [attr.aria-labelledby]="filterLabelId || null"
    [attr.aria-multiselectable]="multiSelect ? 'true' : null">
    @for (key of getQueriedFilterIds(); track key; let index = $index) {
        <li
            #option
            class="sir-filter-option"
            role="option"
            data-cy="filter-dropdown-option"
            [class.sir-filter-option-active]="isActive(key)"
            [attr.aria-selected]="isActive(key) ? 'true' : 'false'"
            [attr.tabindex]="index === activeOptionIndex ? 0 : -1"
            (keydown)="onOptionKeydown($event, index)"
            (click)="$event.stopPropagation(); toggleActive(key)">
            <div class="sir-filter-option-content">
                <span class="sir-filter-option-label" [attr.data-title]="getName(key)">
                    {{ getName(key) }}
                </span>
                <span class="sir-filter-option-icon">
                    <sirius-icon [name]="'check'" [attr.aria-hidden]="true"></sirius-icon>
                </span>
            </div>
        </li>
    }
</ul>
@if (multiSelect) {
    <div class="sir-filter-actions">
        <button
            siriusButton
            buttonType="linkstyle"
            data-cy="filter-dropdown-clear"
            [buttonText]="'button.clear' | translate"
            (click)="$event.stopPropagation(); clearSelection()"
            [disabled]="!hasActiveFilters"></button>
        <button
            siriusButton
            buttonType="primary"
            size="medium"
            data-cy="filter-dropdown-save"
            [buttonText]="'button.save' | translate"
            (click)="$event.stopPropagation(); saveSelection()"></button>
    </div>
}
